// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"0c9e768d","82":"a3dcfdaf","157":"d8d4e4b3","163":"beb85ba8","493":"192f0757","805":"efdc8ac4","895":"0da7a3c0","940":"41471663"}[chunkId] + ".chunk.js";
};